/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No conversations yet" |
*
* @param {Agenda_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_empty_title = /** @type {((inputs?: Agenda_Empty_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Empty_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de conversations")
	return /** @type {LocalizedString} */ ("No conversations yet")
});